import { LinnworksInstallProduct } from "@redotech/redo-integrations-definitions-common/linnworks/linnworks";
import * as z from "zod";

export const getLinnworksInstallationUrl = {
  name: "getLinnworksInstallationUrl" as const,
  input: z.object({ product: z.enum(LinnworksInstallProduct).optional() }),
  output: z.object({
    installAttemptNonce: z.string().uuid(),
    url: z.string().url(),
  }),
};
